import { COIN_GECKO_BASE_RUL, PANEL_COINNIK_BASE_RUL } from "../configs/env";
export const BEST_PRICES = "v1/best-prices";
export const TOKENS = "v1/tokens";
export const LOGIN = "/v1/users/login";
export const USER_PROFILE = "v1/users/profile";
export const COIN_MARKET = "v3/coins/markets";
export const CONTACT = "v1/contact";
export const COINS_MARKETS = (coinName: string) => {
  return `${COIN_GECKO_BASE_RUL}${COIN_MARKET}?vs_currency=usd&ids=${coinName}&order=market_cap_desc&per_page=100&page=1&sparkline=false&price_change_percentage=7d`;
};
export const CONTACTUS = `${PANEL_COINNIK_BASE_RUL}${CONTACT}`;
export const WITHDRAW_FEE = "v1/withdraw-info";
export const DAILY_HISTORY = (symbol: any) => {
  return `v1/price/day-history?pair=${symbol}%2FTMN&limit=180`;
};
